import { render, staticRenderFns } from "./DomainSettings.vue?vue&type=template&id=40b2f5f3"
import script from "./DomainSettings.vue?vue&type=script&lang=js"
export * from "./DomainSettings.vue?vue&type=script&lang=js"
import style0 from "./DomainSettings.vue?vue&type=style&index=0&id=40b2f5f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports